export const sanitizeExperimentGroupName = (groupName: string) => {
  if (groupName.endsWith('_1') || groupName.endsWith('_2')) {
    return groupName.substring(0, groupName.length - 2)
  }

  return groupName
}
